var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenupArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9085 10C11.0909 10 11.2878 9.92565 11.3235 9.73992C11.3554 9.57417 11.3123 9.39471 11.1942 9.26602L8.33704 6.15201C8.15108 5.94933 7.84957 5.94933 7.66361 6.15201L4.80647 9.26602C4.68839 9.39471 4.64529 9.57417 4.67715 9.73992C4.71285 9.92565 4.90973 10 5.09218 10L10.9085 10Z",
    fill: "#61CD82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenupArrow);
export default __webpack_public_path__ + "static/media/greenupArrow.215d10af3b1f5080b1d22488379b542c.svg";
export { ForwardRef as ReactComponent };